// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"fef1b3d3","79":"a05459a0","178":"0cd1fe68","225":"d49da250","239":"5e259d15","427":"eff739f3","430":"355cd0a9","444":"bca284ec","453":"87404a39","517":"359e6e43","522":"54d2e9ae","644":"8900b168","667":"57b9799d","977":"1fe35522","987":"fcd2d2a6"}[chunkId] + ".chunk.js";
};